<template>
  <div class="cms-text-block">
    <h3 v-if="block.title" class="cms-text-block-title">{{ block.title }}</h3>
    <div v-if="block.bodyContent" class="cms-text-block-body" v-html="block.bodyContent"></div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.cms-text-block-title {
  margin: 0 0 10px;
  color: var(--primary);
  font-size: 18px;
  line-height: 1.4;
}

.cms-text-block-body {
  color: var(--text);
  font-size: 15px;
  line-height: 1.8;
}
</style>
